import { useTranslation } from 'react-i18next';

import { Dialog, DialogActions } from '@/components/molecules/dialog';
import { useRemoveBillingGroup } from '@/features/billing-groups/hooks/mutation/use-remove-billing-group';
import { useNavigateBack } from '@/hooks/use-navigate-back';

interface Props extends DialogActions {
  billingGroupId: number;
  billingGroupName: string;
}

const RemoveBillingGroupDialog = ({ open, onCancel, billingGroupId, billingGroupName }: Props) => {
  const { t } = useTranslation(['billingGroups']);

  const { navigateBack } = useNavigateBack();

  const { mutate } = useRemoveBillingGroup(() => {
    onCancel?.();

    navigateBack('/destination-groups');
  });

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      onConfirm={() => mutate(billingGroupId)}
      title={t('billingGroups:create.deletingGroup')}
      variant="warning">
      {`${t('billingGroups:create.areYouSure')}: ${billingGroupName}`}
    </Dialog>
  );
};

export default RemoveBillingGroupDialog;
